import { parseStrictNumber } from './number';

/**
 * Extra data which needs to be saved to backend
 */
export interface Pos {
  xPx: number;
  yPx: number;
}

/**
 * @param  {Pos} sPos start position to calculate angle deg
 * @param  {Pos} ePos end position to calculate angle deg
 * @returns {number}  angle degree
 */
export const getDegBetweenTwoPos = (sPos: Pos, ePos: Pos): number => {
  const angleRadians = Math.atan2(ePos.yPx - sPos.yPx, ePos.xPx - sPos.xPx); // angle in radians
  const angleDeg = (angleRadians * 180) / Math.PI; // angle in degrees
  return angleDeg;
};

/**
 * Returns the distance between positions
 *
 * @param pos1
 * @param pos2
 * @returns
 */
export const getDistance = (pos1: Pos, pos2: Pos) => {
  return Math.sqrt(Math.pow(pos1.xPx - pos2.xPx, 2) + Math.pow(pos1.yPx - pos2.yPx, 2));
};

/**
 * @param  {Pos} pos          x,y position
 * @param  {number} angleDeg  angle degree value for
 * @param  {number} distance
 * @returns {Pos}
 */
export const getPointByAngleDistance = (pos: Pos, angleDeg: number, distance: number): Pos => ({
  xPx: parseStrictNumber(Math.cos((angleDeg * Math.PI) / 180) * distance + pos.xPx),
  yPx: parseStrictNumber(Math.sin((angleDeg * Math.PI) / 180) * distance + pos.yPx),
});
